import Vue from 'vue';
import Router from 'vue-router';
import FlightSearch from '../components/FlightSearch/FlightSearch';
import PassengerInfo from '../components/Passengers/PassengerInfo'
import BookingInfo from '../components/Booking/BookingInfo';
import Error from '../components/Error/Error';
import Refresher from '../components/Refresher/Refresher';
import FlightSearchForwarder from '../components/Forwarder/LandingForwarder';
import SharedLink from '../components/FlightSearch/SharedLink';
import GbQrForwarder from '../components/Forwarder/GbQrForwarder';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes:[
        {
            path:'/gbqrforwarder/:sid/:pm/:mrch',
            name:'GbQrForwarder',
            component: GbQrForwarder
        },
        {
            path:'/',
            name:'FlightSearch',
            component: FlightSearch,
        },
        {
            path:'/flightsearch/:wsid/:urlid/:mlv',
            name:'FlightSearchByAgentSearchBox',
            component: FlightSearch,
        },        
        {
            path:'/passengers/:sid',
            name:'PassengerInfo',
            component: PassengerInfo,
        },
        {
            path:'/booking/:sid',
            name:'BookingInfo',
            component: BookingInfo,
        },
        {
            path:'/booking/:sid/:pm',
            name:'BookingInfoAndPaymentResult',
            component: BookingInfo,
        },        
        {
            path:'/refresh',
            name:'Refresher',
            component: Refresher,
        },
        {
            path:'/error',
            name:'Error',
            component: Error,
        },
        {
            path:'/forwarder/:wsid/:urlid/:rqid/:mlv',
            name:'FlightSearchForwarder',
            component: FlightSearchForwarder,
        },    
        {
            path:'/shared/:sid',
            name:'SharedLink',
            component: SharedLink,
        },            
    ],
});